"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectileType = void 0;
var ProjectileType;
(function (ProjectileType) {
    ProjectileType["Orb"] = "orb";
})(ProjectileType || (exports.ProjectileType = ProjectileType = {}));
